import { makeStyles } from '@fluentui/react-components';
export var useProtectedGradientStyles = makeStyles({
    protectedGradientDiv: {
        position: 'absolute',
        height: 'clamp(460px, 50vw, 720px)',
    },
});
//# sourceMappingURL=ProtectedGradientControl.styles.js.map